export default __webpack_public_path__ + "static/media/hide_professor.76305050.jpeg";